import { QueryClient } from '@tanstack/react-query';

// Module singleton so logout (outside QueryClientProvider) can clear the cache.
// Environment remounts on login; an inline client would still survive as a module
// global — keep one instance and clear it on logout instead.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
      refetchOnMount: true,
    },
  },
});
